module.exports = __webpack_public_path__ + "static/media/favoridecarrental.4f4bdaf8.png";